<template>
  <div class="wallet">
    <div class="card align-center">
      <div class="user">
        <div class="title">账户余额（元）</div>
        <div class="handle">
          <div class="num">{{balance}}</div>
          <div class="btn-view">
            <Button type="primary" class="recharge" @click="$router.push({name:'recharge'})">充值</Button>
            <Button type="text" @click="$router.push({name:'withdrawal'})">提现</Button>
          </div>
        </div>
      </div>
      <div class="total wn60 justify-end">
        <div class="total-item">
          <div class="title">今日支出（元）</div>
          <div class="num">{{today_pay}}</div>
        </div>
        <div class="total-item">
          <div class="title">本周支出（元）</div>
          <div class="num">{{week_pay}}</div>
        </div>
        <div class="total-item">
          <div class="title">本月支出（元）</div>
          <div class="num">{{month_pay}}</div>
        </div>
        <div class="total-item">
          <div class="title">上月支出（元）</div>
          <div class="num">{{upmonth_pay}}</div>
        </div>
      </div>
    </div>
    <div class="block"></div>
    <Form class="filter" inline :label-width="80" :show-message="false" label-position="left">
      <searchFormItemSelect label="业务类型" @on-change="typeChange" :list="type" :value="0" v-model="searFrom.type"></searchFormItemSelect>
     <searchFormItemInput label="订单编号" placeholder="订单编号" v-model="searFrom.order_no"></searchFormItemInput>
      <searchFormItemDate label="发起时间" :list="[{label:'全部',value:''}]" @on-change="timeChange" v-model="searFrom.time" placeholder="请选择时间"></searchFormItemDate>
<!--      <searchFormItemInput label="关键词" placeholder="订单号/姓名/手机号/物流单号"></searchFormItemInput>-->
      <div class="form-footer">
        <searchFormItemButton @on-click="getLog()"></searchFormItemButton>
        <searchFormItemClear @on-clear="clear()"></searchFormItemClear>
      </div>
    </Form>
    <div class="table" v-loading="loading">
      <Table :columns="columns" :data="tableData"></Table>
      <PageComponents
        :total="tableShow.listCount"
        :current="tableShow.currentPage"
        :pageSize="tableShow.pageSize"
        @on-change="changePage"
      ></PageComponents>
    </div>
  </div>
</template>

<script>
import headerComponents from '../../components/header'
import PageComponents from '../../components/page'
import tabNav from '../../components/tabNav'
import {
  searchFormItemSelect,
  searchFormItemDate,
  searchFormItemInput,
  searchFormItemButton,
  searchFormItemClear
} from '../../components/search-form-item'

export default {
  name: 'wallet',
  components: {
    PageComponents,
    searchFormItemButton,
    searchFormItemClear,
    searchFormItemSelect,
    searchFormItemDate,
    searchFormItemInput,
    headerComponents,
    tabNav
  },
  data () {
    return {
      type: [
        {
          label: '全部',
          value: '0'
        },
        {
          label: '充值',
          value: '1'
        },
        {
          label: '提现',
          value: '2'
        },
        {
          label: '支付订单',
          value: '3'
        }
      ],
      loading: true,
      tableShow: {
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searFrom: {
        type: 0,
        start_time: '',
        end_time: '',
        keyword: ''
      },
      balance: 0,
      today_pay: 0,
      month_pay: 0,
      upmonth_pay: 0,
      week_pay: 0,
      columns: [
        {
          title: '交易时间',
          key: 'created_at'
        },
        {
          title: '订单编号',
          key: 'order_no'
        },
        {
          title: '业务类型',
          key: 'instruction'
        },
        {
          title: '金额',
          key: 'value'
        },
        {
          title: '余额（元）',
          key: 'after'
        }
      ],
      tableData: []
    }
  },
  activated () {
    this.loadWalletData()
  },
  methods: {
    loadWalletData () {
    let vm = this

    this.$request('6180ee114528d', {
    }).then(res => {
      vm.balance = res.data.data.balance
      vm.today_pay = res.data.data.today_pay
      vm.month_pay = res.data.data.month_pay
      vm.upmonth_pay = res.data.data.upmonth_pay
      vm.week_pay = res.data.data.week_pay
      console.log(res)
    })

    vm.getLog()
    },
    changePage (page) {
      console.log(page, 'page')
      this.loading = true
      this.tableShow.currentPage = page
      this.getLog()
    },
    timeChange (e) {
      this.searFrom.start_time = e[0]
      this.searFrom.end_time = e[1]
    },
    typeChange (value) {
      console.log(value)
      this.searFrom.type = value
    },
    order_noChange (value) {
      console.log(value)
      this.searFrom.order_no = value
    },
    clear () {
      let vm = this
      vm.searFrom = {
        type: 0,
        start_time: '',
        end_time: '',
        keyword: '',
        time: []
      }
      this.loading = true
      this.getLog()
      console.log(vm.searFrom, 'vm.searFrom')
    },
    getLog () {
      console.log('---888')

      let vm = this
      console.log(vm.searFrom)
      this.$request('6180eb9ac70ba', {
        page: vm.tableShow.currentPage,
        limit: vm.tableShow.pageSize,
        type: vm.searFrom.type.toString(),
        start_time: vm.searFrom.start_time,
        end_time: vm.searFrom.end_time,
        order_number: vm.searFrom.order_no
      }).then(res => {
        vm.tableData = res.data.data
        vm.tableShow.listCount = res.data.count
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.wallet {
  .card {
    display: flex;
    justify-content: space-between;
	flex-direction: row;
    padding: 20px 10px;

    .user {
      min-width: 300px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-size: 18px;
        color: #333;
        font-weight: 700;
      }

      .handle {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .num {
          font-size: 24px;
          color: #333;
        }

        .btn-view {
          margin-left: 60px;

          .recharge {
            margin-right: 10px;
          }
        }
      }
    }

    .total {
      display: flex;
      align-items: center;

      .total-item {
        min-width: 120px;
        margin-left: 10px;

        .title {
          font-size: 12px;
          color: rgb(102, 102, 102);
          letter-spacing: 0;
          line-height: 1;
        }

        .num {
          font-size: 28px;
          color: rgb(17, 17, 17);
          letter-spacing: 0;
          line-height: 1;
          margin-top: 10px;
        }
      }
    }

  }

  .block {
    width: 100%;
    height: 15px;
    background-color: #f7f8fa;
  }

  .filter {
    padding: 10px;
  }

  .table {
    padding: 10px;
  }
}

</style>
